import $ from 'jquery';
window.jQuery = window.$ = $;

import bootstrap from 'bootstrap';

import device from 'current-device';

import './p5.min.js';
import './app.js';
